import axios from "axios";
import env from "../environment";
import storage from "../storage";

export default {
    setup: () => {
        axios.defaults.baseURL = env.apiUrl;

        axios.interceptors.request.use(config => {
            // TODO Check for token refresh

            const accessToken = storage.local.getAccessToken();

            if (accessToken)
                config.headers.Authorization = `Bearer ${accessToken}`;

            return config;
        });

        axios.interceptors.response.use((response) => {
            if (response.status === 401) {
                console.warn('Unauthorized')
                // TODO Redirect to unauthorized page
            }
            if (response.status == 403) {
                console.warn('Forbidden')
                // TODO Redirect to unauthorized page
            }

            return response;
        }, (error) => {
            console.warn('Error response')
            console.log('error:', error)
            if (error.response && error.response.data) {
                return Promise.reject(error.response.data);
            }
            return Promise.reject(error.message);
        });
    }
}
